import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { createElement, forwardRef } from 'react';

import { createNavigation } from 'next-intl/navigation';

export const {
  Link: IntlLink,
  redirect,
  usePathname,
  useRouter,
  getPathname
} = createNavigation();

export const Link = forwardRef<
  ComponentRef<typeof IntlLink>,
  ComponentPropsWithoutRef<typeof IntlLink>
>((props, ref) => {
  const { prefetch, ...rest } = props;
  return createElement(IntlLink, {
    ...rest,
    ref,
    prefetch: prefetch ?? false
  });
});
